import React from 'react';
import Navbar from '../../Components/Common/Navbar/Navbar';
import HomeHeader from '../../Components/Layout/HomeHeader/HomeHeader';
import HomeBanner from '../../Components/Layout/HomeBanner/HomeBanner';

const HomeLayout = (props) => {
    const { children } = props;
    return (
        <main className="HomeLayout">
            <HomeBanner />
            <HomeHeader/>
            {children}
            <Navbar />
        </main>
    );
};

export default HomeLayout;
